var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 77,
    viewBox: "0 0 117 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.9287,
    cy: 70.1026,
    r: 69.0269,
    transform: "rotate(180 46.9287 70.1026)",
    stroke: "#F1613F",
    strokeWidth: 0.545667
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.015,
    cy: 77.1966,
    r: 55.9309,
    transform: "rotate(180 36.015 77.1966)",
    stroke: "#29C302",
    strokeWidth: 0.545667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBottom);
export default __webpack_public_path__ + "static/media/left-bottom.7fdb99a82fd1a5dcc2dd8492e082cddf.svg";
export { ForwardRef as ReactComponent };